// useScrollToRef.js
import { useEffect } from "react";

/**
 * Scroll a ref into view when `trigger` changes, can be used to scroll to a plot or
 * table when it loads, or scroll to the loading message on celery plots
 * @param {React.RefObject} targetRef - Element to scroll to
 * @param {*} trigger - When this changes, scroll to the targetRef, e.g plotData
 * @param {number} delay - ms; defaults to 100
 * @param {useScrollToPlotOptions} options - defaults to smooth/start
 */
export function useScrollToRef(
  targetRef,
  trigger,
  delay = 100,
  options = { behavior: "smooth", block: "start" }
) {
  useEffect(() => {
    if (!trigger || !targetRef?.current) {
      return;
    }

    const id = setTimeout(() => {
      if (targetRef.current) {
        targetRef.current.scrollIntoView(options);
      }
    }, delay);

    return () => clearTimeout(id);
  }, [trigger]);
}

